import {action, observable, computed} from 'mobx';
import {endpoints, types} from 'shared/core';
import {DomainStore} from 'shared/store';

class CalendarsContainerState {
  store = new DomainStore();

  @observable employeeCalendars = [];
  @observable calendarSubscriptions = [];

  @action async load() {
    await this.store._compose([
      endpoints.CALENDAR_SUBSCRIPTIONS,
      endpoints.EMPLOYEE_CALENDARS
    ]);

    this.employeeCalendars = this.store._getAll(types.EMPLOYEE_CALENDAR);
    this.calendarSubscriptions = this.store._getAll(types.CALENDAR_SUBSCRIPTION);
  }

  @computed get hasCalendars() {
    return this.employeeCalendars.length > 0 || this.calendarSubscriptions.length > 0;
  }
}

export default CalendarsContainerState;
